import { render, staticRenderFns } from "./EditUsername.vue?vue&type=template&id=64da0aee&scoped=true&"
import script from "./EditUsername.vue?vue&type=script&lang=js&"
export * from "./EditUsername.vue?vue&type=script&lang=js&"
import style0 from "./EditUsername.vue?vue&type=style&index=0&id=64da0aee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da0aee",
  null
  
)

export default component.exports